import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import Grid from '@material-ui/core/Grid'

import GalleryCarouselStyle from './galleryCarouselStyle.jsx'

const GalleryCardFullInfo = ({classes, item}) => {

    return (
        <div className={classes.sliderContentFixedWidth}>
            <Grid container direction='row' className={classes.sliderContentCardFullInfo}>
                <Grid item className={`${classes.backgroundImage} ${classes.galleryDescriptionFixedHeight}`} style={{backgroundImage : `url(${require('./../../images/' + item.full_image_url)})`}}>
                    <div className={classes.darkOverlay}>
                        <div className={classes.FIContainer}>
                            <div className={classes.galleryFITitle}>
                                {item.title}
                            </div>
                            <div className={classes.galleryFISubtitle}>
                                {item.subtitle}
                            </div>

                            <hr className={classes.smallHr}></hr>

                            <div className={classes.galleryFIDescription} dangerouslySetInnerHTML={{__html: item.description.concat(``)}}>
                            </div>
                        </div>
                    </div>                    
                </Grid>

                <Grid item className={`${classes.visibleSM} ${classes.SMDescription}`}>
                    <div className={classes.galleryFITitle}>
                        {item.title}
                    </div>
                    <div className={classes.galleryFISubtitle}>
                        {item.subtitle}
                    </div>

                    <div className={classes.galleryFIDescription} dangerouslySetInnerHTML={{__html: item.description.concat(``)}}>
                    </div>
                </Grid>  
            </Grid>
        </div>    
    );
}

export default withStyles(GalleryCarouselStyle)(GalleryCardFullInfo)